import React, { Component } from 'react';
import PageTreeCB from '~/components/CheckBox/PageTreeCB';
import PageTreeNode from '~/components/CheckBox/PageTreeNode';
import Second from './Second';
export default class First extends Component {
  state={ display: false }
  render () {
    const { data = {}, value = [], onChange, disabled = false } = this.props;
    const { display } = this.state;
    const { list = [] } = data;
    const haveList = list.length > 0;
    const isAllCheck = () => {
      let Num = 0;
      for (let i = 0; i < list.length; i++) {
        if (value.indexOf(list[i].id) > -1) {
          // return false;
          Num = Num + 1;
        }
      }
      if (Num === list.length) return 2;
      else if (Num > 0) return 1;
      else return 0;
      // return true;
    };
    const clickAll = () => {
      const ary = [];
      if (isAllCheck() === 2) {
        for (let i = 0; i < list.length; i++) {
          ary.push(list[i].id);
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          if (value.indexOf(list[i].id) === -1) { ary.push(list[i].id); }
        }
      }
      onChange(ary);
    };
    return (
      <div style={{ display: 'flex', position: 'relative', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ height: 5, width: haveList ? 20 : 40, backgroundColor: 'black', marginTop: 9 }} />
          {haveList && <PageTreeNode value={display} onClick={() => this.setState({ display: !display })} />}
          {haveList && <div style={{ width: 5 }} />}
          {haveList && <PageTreeCB disabled={disabled} value={isAllCheck() > 0} isLine={isAllCheck() === 1} onClick={clickAll} />}
          {!haveList && <PageTreeCB disabled={disabled} value={value.indexOf(data.id) > -1} onClick={() => onChange([data.id])} />}
          <div style={{ fontSize: 16, marginLeft: 5 }}>{data.name}</div>
        </div>
        {display && list.map((o, i) => <Second disabled={disabled} key={i} data={o} isBottom={list.length === i + 1} value={value} onChange={onChange} />)}
        <div style={{ height: 5 }} />
        <div style={{ position: 'absolute', width: 5, height: '100%', backgroundColor: 'black' }} />
      </div>
    );
  }
}
